import { createGlobalStyle } from 'styled-components';
import '@fontsource/open-sans'; // Defaults to weight 400
import '@fontsource/open-sans/300.css'; // Specify weight
import '@fontsource/open-sans/400.css'; // Specify weight
import '@fontsource/open-sans/500.css'; // Specify weight
import '@fontsource/open-sans/600.css'; // Specify weight
import '@fontsource/open-sans/700.css'; // Specify weight
import '@fontsource/open-sans/800.css'; // Specify weight

//Inter - font
import '@fontsource/inter'; // Defaults to weight 400 (Regular)
import '@fontsource/inter/100.css'; // Weight 100 (Light)
import '@fontsource/inter/200.css'; // Weight 200 (Extra Light)
import '@fontsource/inter/300.css'; // Weight 300 (Light)
import '@fontsource/inter/400.css'; // Weight 400 (Regular)
import '@fontsource/inter/500.css'; // Weight 500 (Medium)
import '@fontsource/inter/600.css'; // Weight 600 (Semi-Bold)
import '@fontsource/inter/700.css'; // Weight 700 (Bold)
import '@fontsource/inter/800.css'; // Weight 800 (Extra Bold)
import '@fontsource/inter/900.css'; // Weight 900 (Black)

export const GlobalStyle = createGlobalStyle`
  html,
  body {
    height: 100%;
    width: 100%;
    overflow: hidden;
  }

  body {
    font-family: 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;
    font-weight: 400;
  }

  #root {
    min-height: 100%;
    min-width: 100%;
  }

  p,
  label {
    font-family: 'Open Sans',  Georgia, Times, 'Times New Roman', serif;
    line-height: 1.5em;
  }

  input, select {
    font-family: inherit;
    font-size: inherit;
  }
  

  // Custom popup style
  .custom-popup {
    .k-window-title {
      visibility: hidden;
    }
    .k-window-titlebar {
        position: absolute;
        z-index: 3;
        right: 0px;
        border: 0px;
        top: 10px;

    .k-button-md.k-icon-button{
        padding-right: 5px;
    }

    }
    .k-dialog-buttongroup{
        display: none;
    }
    .k-dialog {
        overflow: hidden;
    }
  }
// Create or add matser data popup custom styles
.add-matser-data-popup {
  .k-window-content {
    justify-content: center;
    padding: 28px 36px;
    @media (min-width: 300px) and (max-width: 768px) {
      padding: 28px 18px;
    }
  }
  .k-overlay {
    background-color: #D7DEE3;
    opacity: 0.96;
  }
  .k-dialog {
    width: calc(100% - 100px);
    max-width: 930px;
    min-height: 413px;
    border: none;
    border-radius: 15px;
    @media (min-width: 300px) and (max-width: 768px) {
      width: calc(100% - 50px);
    }
  }
  .k-actions {
    padding: 6px 15px;
  }
  @media (min-width: 300px) and (max-width: 768px) {
    .button-wrapper {
      margin-top: 40px;
    }
  }
}
// Close loan popup 
.close-loan-popup {
  .k-window-content {
      gap: 23px;
    }
    .k-overlay {
      background-color: #D7DEE3;
      opacity: 0.96;
    }
    .k-dialog {
      width: 435px;
      min-height: 528px;
      border: none;
      @media (min-width: 300px) and (max-width: 768px) {
        width: 321px;
        height: 323px;
      }
    }
    .k-actions {
      padding: 6px 15px;
    }
    @media (min-width: 300px) and (max-width: 768px) {
    .button-wrapper {
      margin-top: 40px;
    }
    }
}
//autosearch popup
.popupstyle-autosearch{
  .k-list-content{
    ::-webkit-scrollbar {
      width: 2px;
      margin-left: 3px;
    }

    ::-webkit-scrollbar-track {
      background: transparent !important;
      border-radius: 4px;
    }

    ::-webkit-scrollbar-thumb {
      width: 2px;
      background: ${p => p.theme.layoutPageScrollThumbColor} !important;
      border-radius: 4px;
    }
  }
  
}
// Discard popup custom styles 

  .custom-discard-popup {
    .k-window-content {
      gap: 23px;
    }
    .k-overlay {
      background-color: #D7DEE3;
      opacity: 0.96;
    }
    .k-dialog {
      width: 279px;
      min-height: 268px;
      border: none;
      @media (min-width: 300px) and (max-width: 768px) {
        width: 321px;
      }
    }
    .k-actions {
      padding: 6px 15px;
    }
    @media (min-width: 300px) and (max-width: 768px) {
    .button-wrapper {
      margin-top: 40px;
    }
    }
  }
  
  body:has(.custom-discard-popup){
        overflow: hidden;
     }
  .k-animation-container {
    z-index: 10005 !important;
  }
`;
